import { useMemo, useEffect } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { NoAccessError } from '@/lib/errors'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { hasProjectLevelRole } from '@/lib/rbac'
import { CreateAppFallback } from '@/routes/apps/create-app/fallback'
import { CreateAppForm } from '@/routes/apps/create-app/form'

export const CreateAppPage = () => {
  const { idCompany } = useIdCompany()
  const { rbac, rolesInCompany } = useRBAC()

  const hasCreateAccess = useMemo(
    () => rbac.company(idCompany).apps.create.can(),
    [rbac, idCompany]
  )
  const hasProjectAccess = useMemo(
    () => hasProjectLevelRole(rolesInCompany),
    [rolesInCompany]
  )

  useEffect(() => {
    if (!hasCreateAccess && !hasProjectAccess) {
      throw new NoAccessError()
    }
  }, [hasCreateAccess, hasProjectAccess])

  return (
    <LayoutPage browserTitle="Create app" fallback={<CreateAppFallback />}>
      <CreateAppForm />
    </LayoutPage>
  )
}
